<template>
  <div class="custom-actions">
    <button type=button" class="btn btn-link" @click="itemAction('view-item', rowData, rowIndex)"><i class="fas fa-eye"></i></button>
    <button type=button" class="btn btn-primary" @click="editItem(rowData, rowIndex)"><i class="fas fa-pencil-alt"></i></button>
    <button type=button" tclass="btn btn-danger" @click="deleteItem(rowData, rowIndex)"><i class="fas fa-trash-alt"></i></button>
  </div>
</template>

<script>
export default {
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    },
  },
  methods: {
    editItem (data, index) {
      alert("Edit "+data.name)
      //console.log('custom-actions: ' + action, data.name, data.id, index)
    },
    deleteItem (data, index) {
      alert("Delete "+data.name)
      //console.log('custom-actions: ' + action, data.name, data.id, index)
    }
  },
  mounted() {
    console.log("mounted", this.someField);
  }
}
</script>

<style>
  /*.custom-actions button.ui.button {
    padding: 8px 8px;
  }
  .custom-actions button.ui.button > i.icon {
    margin: auto !important;
  }*/
</style>
